import { render, staticRenderFns } from "./CommentControl.vue?vue&type=template&id=7462640e"
import script from "./CommentControl.vue?vue&type=script&lang=js"
export * from "./CommentControl.vue?vue&type=script&lang=js"
import style0 from "./CommentControl.vue?vue&type=style&index=0&id=7462640e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports